import { render, staticRenderFns } from "./AgentEditPageDynamic.vue?vue&type=template&id=606b8b98"
import script from "./AgentEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./AgentEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports